/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/subscribe/:hash'>.
 * был '/subscribe/:hash'
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../../CacheDataRoute';
import Subscribe from '@routes/Subscribe';

export const Route = createFileRoute('/subscribe/$hash')({
  component: () => (
    <CacheDataRoute component={Subscribe} path='/subscribe/:hash' />
  )
});
